<template>
	<v-dialog slot="activator" v-model="dialog" persistent max-width="80vw">
		<v-btn slot="activator" icon >
			<v-icon color="grey darken-2">{{this.icon}}</v-icon>
		</v-btn>
		<v-card>
			<v-toolbar>
				<v-toolbar-title>
					{{ this.newBldg ?  'ADD NEW BUILDING' : 'EDIT BUILDING ' }}
				</v-toolbar-title>
			</v-toolbar>
			<v-card-title class="body-2" color="black"></v-card-title>
			<v-card-text class="pb-5 px-5">
				<v-form v-model="valid" ref="form">
					<v-layout column class="pr-2">
						<v-layout class="mb-4" row>
							<v-flex xs8 class=" pr-2">
								<v-text-field
									class="body-1"
									box
									v-model="building.name"
									@input="changed = true"
									label="Building Name"
									:rules="bldgName"
								>
								</v-text-field>
							</v-flex>
							<v-flex xs2 class=" pr-2">
								<v-text-field
									class="body-1"
									box
									hint="Example: 0300.00"
									v-model="building.bldgNumber"
									@input="changed = true"
									label="Building Number"
									:rules="requiredRules"
								>
								</v-text-field>
							</v-flex>
							<v-flex xs2 class=" pr-2">
								<v-text-field
									class="body-1"
									hint="Example: 300A"
									box
									v-model="building.bldgAlpha"
									@input="changed = true"
									label="Building Alpha"
									:rules="requiredRules"
								>
								</v-text-field>
							</v-flex>							
						</v-layout>

						<v-layout row class="mb-2">
							<v-flex xs3 class=" pr-2">
								<v-text-field
									class="body-1"
									box
									v-model="building.abbrev"
									@input="changed = true"
									label="Abbrev"
									:rules="abbrevRules"
								>
								</v-text-field>
							</v-flex>
							<v-flex xs3 class=" pr-2">
								<v-text-field
									class="body-1"
									box
									v-model="building.commonName"
									@input="changed = true"
									label="Common Name"
									:rules="bldgNameCommonRules"
								>
								</v-text-field>
							</v-flex>
							<v-flex xs3 class=" pr-2">
								<v-text-field
									class="body-1"
									box
									v-model="building.shortName"
									@input="changed = true"
									label="Short Name"
									:rules="bldgNameShortRules"
								>
								</v-text-field>
							</v-flex>
							<v-flex xs3 class=" pr-2">
								<v-text-field
									class="body-1"
									box
									v-model="building.aliasName"
									@input="changed = true"
									label="Alias"
									:rules="bldgAliasRules"
								>
								</v-text-field>
							</v-flex>
						</v-layout>

						<v-layout row class="mb-2">
							<v-flex xs3 class=" pr-2">
								<v-text-field
									class="body-1"
									box
									v-model="building.address"
									@input="changed = true"
									label="Address"
									:rules="addressRules"
								>
								</v-text-field>
							</v-flex>
							<v-flex xs3 class=" pr-2">
								<v-text-field
									class="body-1"
									hide-details
									box
									v-model="building.city"
									@input="changed = true"
									label="City"
								>
								</v-text-field>
							</v-flex>
							<v-flex xs3 class=" pr-2">
								<v-text-field
									class="body-1"
									box
									v-model="building.state"
									@input="changed = true"
									label="State"
									:rules="stateRules"
								>
								</v-text-field>
							</v-flex>
							<v-flex xs3 class=" pr-2">
								<v-text-field
									class="body-1"
									box
									v-model="building.zip"
									@input="changed = true"
									label="Zip"
									:rules="zipRules"
								>
								</v-text-field>
							</v-flex>							
						</v-layout>

						<v-layout row class="mb-5">
							
							<!-- <v-flex xs3 class=" pr-2">
								<v-text-field
									class="body-1"
									hide-details
									box
									v-model="building.sortAddress"
									@input="changed = true"
									label="Sort Addr"
								>
								</v-text-field>
							</v-flex> -->
						</v-layout>

						

						<v-layout row class="mb-2">
							<!-- <v-flex xs3 class="pr-2">
								<v-autocomplete
									:items="buildingConstruction"
									@input="changed=true"	
									class="body-1"							
									item-text="IDAndName"								
									item-value="constructionTypeCode"
									v-model="building.constructionType"								
									flat
									light
									hide-no-data
									hide-details
									label="Construction"
									box
								></v-autocomplete>
							</v-flex> -->
							<v-flex xs3 class=" pr-2">
								<v-text-field
									class="body-1"
									hide-details
									box
									v-model="building.route"
									@input="changed = true"
									label="Route"
								>
								</v-text-field>
							</v-flex>
							<v-flex xs3 class=" pr-2">
								<v-autocomplete
									:items="buildingOwnership"
									@input="changed=true"
									class="body-1"									
									item-text="IDAndName"								
									item-value="ownershipCode"
									v-model="building.ownershipCode"								
									flat
									light
									hide-no-data
									hide-details
									label="Ownership"
									box
								></v-autocomplete>
							</v-flex>

						<v-flex xs3 class=" pr-2">
							<v-autocomplete
								:items="buildingPlanAreas"
								@input="changed=true"
								class="body-1"									
								item-text="IDAndName"															
								item-value="planAreaCodeID"
								v-model="building.planAreaCode"		
								flat
								light
								hide-no-data
								hide-details
								label="Plan Area"
								box
							></v-autocomplete>
						</v-flex>					
						<v-flex xs3 class=" pr-2">
							<v-autocomplete
								:items="statusItems"
								@input="changed=true"
								class="body-1"	
								v-model="building.status"								
								flat
								light
								hide-no-data
								hide-details
								label="Status"
								box
							></v-autocomplete>
						</v-flex>
						</v-layout>

						<v-layout row class="mb-2">
							<v-flex xs3 class=" pr-2">
								<v-menu
						          ref="menu2"
						          v-model="menu2"
						          :close-on-content-click="false"
						          :nudge-right="40"
						          lazy
						          transition="scale-transition"
						          offset-y
						          full-width
						          max-width="290px"
						          min-width="290px"
						        >
						          <template v-slot:activator="{ on }">
						            <v-text-field
						              v-model="building.dateConstructed"
						              label="Construction Date"
						              class="body-1"	
						              flat
						              box
						              readonly
									  clearable
						              v-on="on"
						            ></v-text-field>
						          </template>
						          <v-date-picker v-model="building.dateConstructed" 
						          	@input="changed = true; menu2 = false"></v-date-picker>
						        </v-menu>
							</v-flex>

							<v-flex xs3 class=" pr-2">
								<v-menu
						          ref="menu1"
						          v-model="menu1"
						          :close-on-content-click="false"
						          :nudge-right="40"
						          lazy
						          transition="scale-transition"
						          offset-y
						          full-width
						          max-width="290px"
						          min-width="290px"
						        >
						          <template v-slot:activator="{ on }">
						            <v-text-field
						              v-model="building.dateBuildingAdj"
						              label="Adjusted Date"
						              class="body-1"
						              flat
						              box
						              readonly
									  clearable
						              v-on="on"
						            ></v-text-field>
						          </template>
						          <v-date-picker v-model="building.dateBuildingAdj" 
						          	@input="changed = true; menu1 = false"></v-date-picker>
						        </v-menu>
					        </v-flex>

					        <v-flex xs3 class=" pr-2">
					        	<v-menu
						          ref="menu3"
						          v-model="menu3"
						          :close-on-content-click="false"
						          :nudge-right="40"
						          lazy
						          transition="scale-transition"
						          offset-y
						          full-width
						          max-width="290px"
						          min-width="290px"
						        >
						          <template v-slot:activator="{ on }">
									<v-text-field
						              v-model="building.dateDeleted"
						              label="Deleted Date"
						              class="body-1"
						              flat
						              box
						              clearable
									  readonly
						              v-on="on">              	
						        	</v-text-field>	
						        	</template>
						          <v-date-picker v-model="building.dateDeleted" 
						          	@input="changed = true; menu1 = false"></v-date-picker>
						        </v-menu>					      
					        </v-flex>
						

					        <v-flex xs3>
					        	<v-layout row class="ml-5">
								<v-flex class=" pr-2">
									<v-checkbox
										v-model="building.resCode"
										true-value="R"
										false-value="N"
										label="Residential"
									></v-checkbox>
								</v-flex>
								<v-flex class=" pr-2">
									<v-checkbox
										v-model="building.historic"
										true-value="1"
										false-value="0"
										label="Historic"
									></v-checkbox>
								</v-flex>	
								</v-layout>
							</v-flex>						
							
						</v-layout>
						
						<v-flex xs3 class="mt-5 pr-2">
							<v-text-field
								class="body-1"
								hide-details
								box
								v-model="building.comment"
								@input="changed = true"
								label="Comment"
							>
							</v-text-field>
						</v-flex>
						
					</v-layout>
				</v-form>
			</v-card-text>
			<v-card-actions class="pb-5 px-5">
				<EditBuildingReplacement v-if="!this.newBldg" />
				<v-spacer></v-spacer>
				<v-btn color="green darken-1" flat @click.native="reset">
					Cancel
				</v-btn>
				<v-btn color="green darken-1" flat @click.native="save">
					{{this.newBldg ? 'Add' : 'Save'}}
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import Vuex from "vuex";
import { mapState, mapMutations, mapActions } from "vuex";
import EditBuildingReplacement from './EditBuildingReplacement'

export default {
	name: "EditBuildingDialog",

	components: { EditBuildingReplacement },

	data() {
		return {
			initialStatus: null,
			valid: false,
			dialog: false,
			menu1: false,
			menu2: false,
			menu3: false,
			building: null,
			newBuilding: {
				newBldg: true,
				bldgNumber: null,
				bldgAlpha: null,
				name: null,
				address: null,
				city: null,
				state: null,
				zip: null,
				sortAddress: null,
				abbrev: null,
				commonName: null,
				shortName: null,
				aliasName: null,
				route: null,
				resCode: 'N',
				historic: '0',
				dateBuildingAdj: null,
				dateConstructed: null,
				constructionType: null,
				ownershipCode: null,
				conditionCode: null,
				planAreaCode: null,
				comment: null,
				status: 'P'
			},
			requiredRules:  [	v => !!v || "Field is required", ],
			stateRules: 	[	v => !v || (v || '').length == 2 || "2 character format required", ],
			zipRules: 	[	v => !v || (v || '').length == 5 || "5 characters required", ],
			bldgName: 	[	v => !v || (v || '').length <= 70 || "70 characters maximum", v => !!v || "Field is required", ],
			bldgNameCommonRules: [	v => !v || (v || '').length <= 50 || "50 characters maximum", ],
			bldgNameShortRules: [	v => !v || (v || '').length <= 40 || "40 characters maximum", ],
			abbrevRules: [	v => !v || (v || '').length <= 20 || "20 characters maximum", ],
			bldgAliasRules: [	v => !v || (v || '').length <= 50 || "50 characters maximum", ],
			addressRules: [	v => !v || (v || '').length <= 100 || "100 characters maximum", ],
			

			statusItems: 	[ 	{ value: 'A', text: 'Active' },
								{ value: 'P', text: 'Pending' },
								{ value: 'D', text: 'Deleted' },
								{ value: 'NS', text: 'Non-Space Inventoried'} 

							]
		};
	},

	created: function() {
		this.fetchBuildingDropdowns()
		this.building = this.dvBuilding || { ...this.newBuilding } 
	},

	props: [ 'newBldg', 'icon' ],



	watch: {
		// If prop is for newBldg, use copy of newBuilding.  Otherwise if there is a building selected, edit that OR use newBuilding.
		dialog (val) { 
			if (val) { 
				this.building = this.newBldg ? { ...this.newBuilding } : this.dvBuilding || { ...this.newBuilding } 
				this.initialStatus = this.building.status
				console.log("Initial Status: ", this.initialStatus)
			} 

		},
},

	computed: {
		...mapState({
			dvBuilding: state => state.dv.building,
			buildingOwnership: state => state.lists.buildingOwnership,
			buildingPlanAreas: state => state.lists.buildingPlanAreas,
		}),

		

	},

	methods: {
		...mapMutations([	'setSnackText', 'setdvBuilding', 'setdvFloor']),
		...mapActions([	 	'saveBuilding', 'fetchBuildings', 'initializeData', 
							'fetchBuildingDropdowns', 'refreshBuilding']),

		getText: function (item) {
			return item && item.planAreaCodeID + "-" + item.planAreCodeName
		},

		save: function() {

			if (!this.valid) {
				this.setSnackText("Form has validation errors");
				return;
			}

			if (this.newBldg) { this.building.newBldg = true }

			// If status was changed to Delete, update the dateDeleted field
			if (this.initialStatus != 'D' && this.building.status == 'D') { 
				this.building.dateDeleted = new Date().toISOString().slice(0,10) 
			}
			
			this.saveBuilding(this.building).then((response) => {
				this.setSnackText(response)
				if (response == "Saved") {
					this.reset()

					//refresh
					this.fetchBuildings().then((data) => {
						let newBldg = data.find((building) => { return building.bldgAlpha == this.building.bldgAlpha })
						this.setdvBuilding(newBldg)
						this.refreshBuilding(newBldg.bldgAlpha)
					})
					
				}
			})			
		},

		reset: function() {			
			//this.refreshBuilding(this.building.bldgAlpha)
			this.dialog = false;	
		}
	}
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/forms/BldgViewer/EditBuildingDialog.vue